import { Injectable } from '@angular/core';
import { FirebaseApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirebaseAppService {
  private readonly app: FirebaseApp;

  constructor() {
    const config = (environment as any).firebase;
    if (!config?.apiKey || !config?.authDomain || !config?.projectId || !config?.appId) {
      throw new Error('Missing firebase configuration in environment.firebase');
    }

    const existing = getApps().find((a) => a.name === 'everest-auth');
    this.app = existing || initializeApp(config, 'everest-auth');
    getAuth(this.app);
  }

  getApp(): FirebaseApp {
    return this.app;
  }
}

